import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@shared/shared.module';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { ContatoListComponent } from './contato-list/contato-list.component';
import { ContatoFormComponent } from './contato-form/contato-form.component';
import { ContatoModalComponent } from './contato-modal/contato-modal.component';
import { OutrosContatosFormComponent } from './outros-contatos-form/outros-contatos-form.component';
import { OutrosContatosListComponent } from './outros-contatos-list/outros-contatos-list.component';
import { CepMaskPipe } from '@shared/pipes/cep-mask.pipe';
import { TelefoneXXPipe } from '@shared/pipes/telefone-xx.pipe';

@NgModule({
  declarations: [
    ContatoListComponent,
    ContatoFormComponent,
    ContatoModalComponent,
    OutrosContatosFormComponent,
    OutrosContatosListComponent,
    // CepMaskPipe
  ],
  exports:[
    ContatoListComponent,
    ContatoFormComponent,
    ContatoModalComponent,
    OutrosContatosFormComponent,
    OutrosContatosListComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgxMaskDirective,
    NgxMaskPipe
  ],
  providers: [
    provideNgxMask()
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ContatoModule { }
